import { createStore, createEvent } from 'effector';
import { LocalStorageUtils } from '@shared/utils';

const setIsCollapsed = createEvent<boolean>();
const clearEvent = createEvent();

const $store = createStore<boolean>(LocalStorageUtils.getMenuIsCollapsed())
  .on(setIsCollapsed, (_, data) => data)
  .reset(clearEvent);
$store.watch((isCollapsed) => LocalStorageUtils.setMenuIsCollapsed(isCollapsed));

export const $menuStore = {
  events: {
    setIsCollapsed: setIsCollapsed,
    clear: clearEvent,
  },
  store: $store,
};
